<template>
<div>
  <div v-if="this.insPage">
    <v-btn color="primary" class="mr-2" block x-large rounded fab :to="{ name: 'InsDSMdata' }">
      <h1>新增宅配單</h1>
    </v-btn>
  </div>
  <div v-else>
    <v-btn color="primary" class="mr-2" block x-large rounded fab disabled>
      <h1>新增宅配單</h1>
    </v-btn>
  </div>
  <br /><br />

  <div v-if="this.updPage">
    <v-btn color="primary" class="mr-2" block x-large rounded fab :to="{ name: 'UpdDSMdata' }">
      <h1>修改宅配單</h1>
    </v-btn>
  </div>
  <div v-else>
    <v-btn color="primary" class="mr-2" block x-large rounded fab disabled>
      <h1>修改宅配單</h1>
    </v-btn>
  </div>
  <br /><br />

  <div v-if="this.searchPage">
    <v-btn color="primary" class="mr-2" block x-large rounded fab :to="{ name: 'SerchDSM_D' }">
      <h1>查詢宅配單</h1>
    </v-btn>
  </div>
  <div v-else>
    <v-btn color="primary" class="mr-2" block x-large rounded fab disabled>
      <h1>查詢宅配單</h1>
    </v-btn>
  </div>
</div>
</template>

<script>
export default {
  name: "VerifyUser",
  props: ["accountId", "password"],
  data() {
    return {
      insPage: true,
      updPage: true,
      searchPage: true,
    };
  },
  mounted: function() {
    this.checkPage();
  },
  methods: {
    checkPage: function() {
      if (this.$cookie.get('page_token') != 'C') {
        this.$router.push({
          name: "ErrorPage"
        });
      } else {
        let page_token = 'S';
        this.$cookie.set('page_token', page_token, "0");

        if (this.$cookie.get('dsm_type') === '0') {
          this.insPage = true
          this.updPage = false
          this.searchPage = false
        } else if (this.$cookie.get('dsm_type') === '1') {
          this.insPage = false
          this.updPage = true
          this.searchPage = false
        } else if (this.$cookie.get('dsm_type') === '2') {
          this.insPage = false
          this.updPage = false
          this.searchPage = true
        } else {
          this.insPage = false
          this.updPage = false
          this.searchPage = false
        }
      }
    },
  },
}
</script>
